import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'sonner';

const LOGO_URL = "/logo.png";

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user } = useAuth();
  const navigate = useNavigate();

  // Redirect if already logged in
  if (user && user.role === 'admin') {
    navigate('/admin');
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Erfolgreich angemeldet');
      navigate('/admin');
    } catch (error) {
      const message = error.response?.data?.detail || 'Anmeldung fehlgeschlagen';
      toast.error(typeof message === 'string' ? message : 'Anmeldung fehlgeschlagen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#131d30] flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="Dogan Immobilien" className="h-16 mx-auto mb-6" />
          <h1 className="font-display text-2xl text-white">Admin-Bereich</h1>
          <p className="text-[#c8c6c4] text-sm mt-2">
            Melden Sie sich an, um fortzufahren
          </p>
        </div>

        <form onSubmit={handleSubmit} className="card-luxury p-8 space-y-6">
          <div>
            <label htmlFor="email" className="block text-sm text-[#c8c6c4] mb-2">
              E-Mail
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-luxury w-full"
              placeholder="ihre@email.de"
              data-testid="login-email"
            />
          </div>

          <div>
            <label htmlFor="password" className="block text-sm text-[#c8c6c4] mb-2">
              Passwort
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-luxury w-full"
              placeholder="••••••••"
              data-testid="login-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="btn-primary w-full"
            data-testid="login-submit"
          >
            {loading ? 'Wird angemeldet...' : 'Anmelden'}
          </button>
        </form>

        <p className="text-center text-[#c8c6c4]/50 text-sm mt-8">
          <a href="/" className="hover:text-[#d1af6a]">
            ← Zurück zur Website
          </a>
        </p>
      </div>
    </div>
  );
}
